var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaincontent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4587 22.3353H13.7087M3.91699 22.3353V13.2878C3.91699 9.29277 7.14824 6.06152 11.1432 6.06152H22.1491C26.1441 6.06152 29.3753 8.54861 29.3753 12.5436",
    stroke: "white",
    strokeWidth: 2.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.232 24.3919C33.2528 25.3319 32.7828 26.781 33.1745 28.2694C33.6641 30.0906 35.4657 31.246 37.3457 31.246H39.167V34.0856C39.167 38.4135 35.6616 41.9189 31.3337 41.9189H11.7503C7.42241 41.9189 3.91699 38.4135 3.91699 34.0856V20.3773C3.91699 16.0494 7.42241 12.5439 11.7503 12.5439H31.3337C35.642 12.5439 39.167 16.0689 39.167 20.3773V23.2169H37.052C35.9553 23.2169 34.9566 23.6477 34.232 24.3919Z",
    stroke: "white",
    strokeWidth: 2.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0836 25.2143V29.2485C43.0836 30.3451 42.1828 31.246 41.0665 31.246H37.2869C35.1719 31.246 33.2332 29.6989 33.0569 27.5839C32.9394 26.3501 33.4094 25.1947 34.2319 24.3918C34.9565 23.6476 35.9553 23.2168 37.0519 23.2168H41.0665C42.1828 23.2168 43.0836 24.1176 43.0836 25.2143Z",
    stroke: "white",
    strokeWidth: 2.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaincontent);
export default __webpack_public_path__ + "static/media/maincontent.547103ef207cf63a6004925ac4f7086d.svg";
export { ForwardRef as ReactComponent };